/* ====================================================================
   Oduree - Verwijsprogramma (referral)
   ====================================================================
   1. Landing via persoonlijke link  oduree.nl/?ref=<token>
        -> token 30 dagen onthouden (localStorage) en als cart-attribuut
           _oduree_ref op de winkelwagen zetten. De Shopify Function
           "referral-korting" geeft daarop 10% vriendenkorting (alleen nieuwe
           klanten, nooit de linkeigenaar zelf; die controle zit ook in de
           functie, dit script is alleen het doorgeefluik).
   2. Accountpagina: kopieerknop voor de eigen link.
   Het token wordt hier niet gecontroleerd op echtheid; dat doen de functie
   (bij de korting) en de worker (bij de beloning) met het secret.
   ==================================================================== */
(function () {
  "use strict";

  if (window.OdureeReferral && window.OdureeReferral._initialized) return;

  var STORAGE_KEY = "oduree_ref";
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var ATTR = "_oduree_ref";
  var TOKEN_RE = /^\d{1,20}\.[0-9a-f]{6}\.[0-9a-f]{10}$/i;
  var cfg = window.ODUREE_REFERRAL || {};
  var busy = false;

  function lees() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return "";
      var obj = JSON.parse(raw);
      if (!obj || !obj.token || !obj.ts || Date.now() - obj.ts > TTL_MS) return "";
      return TOKEN_RE.test(obj.token) ? obj.token : "";
    } catch (e) { return ""; }
  }

  function bewaar(token) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ token: token, ts: Date.now() })); } catch (e) {}
  }

  function wis() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // Eigen link? Dan negeren: de linkeigenaar krijgt zelf geen korting.
  function isEigen(token) {
    var id = String(token).split(".")[0];
    return !!cfg.customerId && String(cfg.customerId) === id;
  }

  function vangParamOp() {
    var url;
    try { url = new URL(window.location.href); } catch (e) { return; }
    var ref = (url.searchParams.get("ref") || "").trim().toLowerCase();
    if (!ref) return;
    url.searchParams.delete("ref");
    try { window.history.replaceState({}, document.title, url.pathname + (url.search || "") + (url.hash || "")); } catch (e) {}
    if (!TOKEN_RE.test(ref) || isEigen(ref)) return;
    bewaar(ref);
  }

  // Cart-attribuut in de pas brengen met het onthouden token.
  function sync() {
    if (busy) return Promise.resolve();
    var token = lees();
    if (token && isEigen(token)) { wis(); token = ""; }
    busy = true;
    return (window.OdureeCart && typeof window.OdureeCart.get === "function"
      ? window.OdureeCart.get()
      : fetch("/cart.js", { cache: "no-store", headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }))
      .then(function (cart) {
        var huidig = String((cart && cart.attributes && cart.attributes[ATTR]) || "");
        if (huidig === token) return null;
        if (!token && !huidig) return null;
        var attrs = {};
        attrs[ATTR] = token; // lege string wist het attribuut
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ attributes: attrs }),
        }).then(function () { return "updated"; });
      })
      .then(function (actie) {
        busy = false;
        if (actie && window.CartDrawer && typeof window.CartDrawer.refresh === "function" && window.CartDrawer.isOpen && window.CartDrawer.isOpen()) {
          return window.CartDrawer.refresh();
        }
      })
      .catch(function (err) {
        busy = false;
        console.warn("[OdureeReferral] sync error", err);
      });
  }

  function bindKopieer() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-referral-copy], [data-copy-text]");
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest("[data-referral-card]");
      var input = card && card.querySelector("[data-referral-link]");
      var tekst = btn.getAttribute("data-copy-text") || (input && input.value) || "";
      if (!tekst) return;
      var klaar = function () {
        var origineel = btn.textContent;
        btn.textContent = btn.getAttribute("data-copied-label") || origineel;
        btn.disabled = true;
        setTimeout(function () { btn.textContent = origineel; btn.disabled = false; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(tekst).then(klaar).catch(function () { if (input) input.select(); klaar(); });
      } else {
        if (input && !btn.getAttribute("data-copy-text")) input.select();
        try { document.execCommand("copy"); } catch (err) {}
        klaar();
      }
    });
  }

  function init() {
    vangParamOp();
    bindKopieer();
    sync();
    document.addEventListener("cart:updated", function () { sync(); });
    window.addEventListener("pageshow", function () { sync(); });
    springNaarKaart();
  }

  /* Footer-link "Jouw persoonlijke link" -> direct naar de kaart op de
     accountpagina. Bij een login-omweg verliest Shopify de #hash; daarom
     onthouden we de klik kort in sessionStorage en springen we na het
     laden alsnog. */
  var JUMP_KEY = "oduree_ref_jump";
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("[data-referral-jump]");
    if (!a) return;
    try { sessionStorage.setItem(JUMP_KEY, "1"); } catch (_) {}
  });
  function springNaarKaart() {
    var kaart = document.querySelector("[data-referral-card]");
    if (!kaart) return;
    var wil = location.hash === "#deel-oduree";
    try { if (sessionStorage.getItem(JUMP_KEY)) { wil = true; sessionStorage.removeItem(JUMP_KEY); } } catch (_) {}
    if (!wil) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setTimeout(function () {
      kaart.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    }, 250);
  }

  window.OdureeReferral = { _initialized: true, sync: sync, token: lees };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
